<template>
  <v-container
    id="treinamentos"
    fluid grey lighten-4 
    class="pa-0 my-0 py-12"
  >
    <v-row
      class="pt-12 justify-center"
    >
      <v-col cols="12" class="text-center">
        <h3 class="body-1 font-weight-regular pt-3">
          <span class="barlow grey--text text--darken-3">treinamentos para seu</span>
        </h3>
        <h2 class="display-1 font-weight-bold pt-0">
          <span class="barlow primary--text">DESENVOLVIMENTO PESSOAL</span>
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="pt-8 pb-12 px-12 justify-center"
    >
      <v-col
        v-for="(t,i) in treinamentos"
        :key="i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          :hover="url(t.url)"
          tile flat
          class="pb-4 fill-height white grey--text text--darken-4 text-left" 
          :href="t.url"
          target="_blank"
        >
          <v-img
            class=""
            height=""
            :src="getImg(t.imagem)"
          >
          </v-img>
          <v-card-subtitle class="pb-0 caption text-uppercase">
            <span class="font-weight-medium primary--text">
              {{t.categoria}}
            </span>
          </v-card-subtitle>
          <v-card-title class="pt-0 pb-1 headline">
            <span class="barlow font-weight-bold">{{t.titulo}}</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <span>{{t.descricao}}</span>
          </v-card-text>
          <v-card-actions class="pt-0 px-3">
            <div class="body-2">
              <v-icon class="grey--text text--darken-3">mdi-calendar</v-icon>
              <span
                class="font-weight-bold"
                :class="{
                  'primary--text' : t.url
                }"
              >{{t.data}}</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              v-if="t.url"
              class="primary"
            >Inscreva-se <v-icon class="">mdi-chevron-right</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import posts from '~/store/posts'
// import axios from '~/plugins/axios'

export default {
  data: () => ({
    treinamentos: [
      {
        //url: 'https://souluzesombra.com.br?utm_source=site&utm_medium=bloco-site&utm_campaign=luz-e-sombra-fortaleza-2020',
        url: '',
        imagem: 'luz-e-sombra-aberto.jpg',
        categoria: 'TREINAMENTO VIVENCIAL',
        titulo: 'Luz e Sombra',
        descricao: 'Luz e Sombra é um processo único de dois dias intensos, profundos e transformadores. Você merece viver o melhor! Sucesso de público e de crítica, o Treinamento Vivencial Luz e Sombra acontece desde 2014, já impactou centenas de pessoas e foi desenvolvido pensando em você que, através do AUTOCONHECIMENTO, busca crescimento pessoal, crescimento profissional e melhorar seus relacionamentos.',
        data: 'AGUARDE!'
      },
      {
        url: '',
        imagem: 'lidere-se.jpg',
        categoria: 'CURSO PRESENCIAL',
        titulo: 'Lidere-se',
        descricao: 'Treinamento Sobre Auto-Liderança. Você já se perguntou porque ainda não chegou no seus objetivos? Você já se perguntou porque para no meio do caminho para suas metas? Porque viver na média, se você pode ser EXTRAORDINÁRIO! Venha descobrir caminhos para começar a alcançar aquilo que você tem sonhado. Um treinamento único e exclusivo onde você terá a oportunidade de experimentar como será nossa imersão de dois dias Você Liderando. Temas importantes: MUDANÇA DE MENTALIDADE; QUEBRA DE CRENÇAS LIMITANTES; TRANSFORMAÇÃO DE HÁBITOS; PRINCÍPIOS E AÇÕES PARA AUTO; LIDERANÇA.',
        data: 'AGUARDE!'
      },
      {
        url: '',
        imagem: 'agp.jpg',
        categoria: 'CURSO PRESENCIAL',
        titulo: 'Acessando seu Gênio Pessoal',
        descricao: 'Acessando Seu Gênio Pessoal foi desenhado para treinar a compreensão do modelo Meta-estado, que significa desenvolver a capacidade de pensar e sentir em relação a um estímulo interno ou externo. Ou seja, este gênio é você, é o seu potencial de conexão, sua criatividade infinita, desenvolvimento de relacionamentos, investigação, aprendizado e descobertas.',
        data: 'AGUARDE!'
      }
    ],
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/treinamentos/'+i)
    },
    url (val) {
      return val != null ? true : false
    },
  },
  created () {
    //this.posts = posts.getPosts()
  },

}
</script>